import ApiClient from '@/api/ApiClient';
import Certificate from '@/api/models/Certificate';

class UserCourseService {
    #prefixUrl = 'api/user_course/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets Course certificate
     * @param {string} courseId 
     */
    async getUserCourseCertificate(courseId) {
        const response = await this.api.executeRequest(`certificate/${courseId}`, {}, this.api.methods.GET);

        let certificate = null;
        if (response.success()) {
            certificate = new Certificate(response.getContent());
            await certificate.certificate_assets.parseFiles();
        }

        return certificate;
    }

    /**
     * Updates Certificate name
     * @param {string} certificateUuid 
     * @param {string} newCertificateName 
     * @returns {Response}
     */
    async requestCertificateNameChange(certificateUuid = null, newCertificateName = '') {
        return await this.api.executeRequest(`certificate_update/${certificateUuid}`, { newCertificateName: newCertificateName }, this.api.methods.POST);
    }
}

export default new UserCourseService();
